import React, { HTMLAttributes } from 'react';
import { BiMinus, BiPlus } from 'react-icons/bi';

import { Container, Content } from './styles';

type IncrementDecrementProps = HTMLAttributes<HTMLDivElement> & {
  label?: string;
  max?: number;
  min?: number;
  value: number;
  onChangeValue(value: number): void;
};

const IncrementDecrement: React.FC<IncrementDecrementProps> = ({
  id,
  label,
  max,
  min,
  value,
  onChangeValue,
  ...rest
}) => {
  const canDecrement = typeof min === 'number' ? value > min : true;
  const canIncrement = typeof max === 'number' ? value < max : true;

  return (
    <Container>
      {label && <label htmlFor={id}>{label}</label>}
      <Content {...rest}>
        <button
          type="button"
          disabled={!canDecrement}
          onClick={() => onChangeValue(value - 1)}
        >
          <BiMinus />
        </button>
        <span>{value}</span>
        <button
          type="button"
          disabled={!canIncrement}
          onClick={() => onChangeValue(value + 1)}
        >
          <BiPlus />
        </button>
      </Content>
    </Container>
  );
};

export default IncrementDecrement;
